"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areEqualObjects = void 0;
const deepEqual = require("deep-equal");
const areEqualObjects = (obj1, obj2) => deepEqual(obj1, obj2, { strict: true });
exports.areEqualObjects = areEqualObjects;
//# sourceMappingURL=areEqualObjects.js.map